var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"g_id_signin2",attrs:{"id":"g_id_signin2"}})])
}]

export { render, staticRenderFns }